module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/12vWjHX/tc-custom/9781452156859.jpg?1729082793387",
      "alt": "This image is the cover for the book Ama"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Ama\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("The chef behind LA’s beloved Tex-Mex restaurant shares 100+ creative recipes inspired by regional Mexican cuisine and global flavors.")])]), _c('p', [_vm._v(" Hailing from San Antonio, chef Josef Centeno drew on traditional family recipes for his acclaimed restaurant Bar Ama. Starting with a foundation of regional Mexican cuisine, he ventured far and wide, with influences from the American South, Germany, Poland, and Morocco. Now, with this irresistible collection of recipes, he helps you bring the same diverse and delicious flavors into your kitchen. ")]), _c('p', [_vm._v(" With more than 100 recipes, "), _c('i', [_vm._v("Ama")]), _vm._v(" is divided into chapters on breakfast, vegetables, and main courses as well as desserts and even a super nacho party. Full color photos throughout capture the mouthwatering dishes as well as the incomparable atmosphere of Bar Ama. ")]), _c('b', [_vm._v("An Eating the West Award Finalist 2020")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Betty Hallock, Josef Centeno, Ren Fuller\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Chronicle Books LLC\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0